// src/routes/AuthGuard.tsx or similar
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthService } from '@/rtkQuery/features/hooks/useAuthService';

const LoadingSpinner = () => (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading...</p>
        </div>
    </div>
);

interface AuthGuardProps {
    children: ReactNode;
    requireAuth?: boolean;
}

export const AuthGuard = ({ children, requireAuth = true }: AuthGuardProps) => {
    const { isAuthenticated, loginIsLoading } = useAuthService();
    const location = useLocation();

    const currentPath = location.pathname + location.search + location.hash;

    if (loginIsLoading) {
        return <LoadingSpinner />;
    }

    if (requireAuth && !isAuthenticated) {
        sessionStorage.setItem('redirectAfterLogin', currentPath);
        return <Navigate to="/login" replace />;
    }

    if (!requireAuth && isAuthenticated) {
        const redirectTo = sessionStorage.getItem('redirectAfterLogin') || '/';
        sessionStorage.removeItem('redirectAfterLogin');
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};
